export const APP_SECTIONS_ID = "appSections";
export const AVAILABLE_SECTIONS_ID = "availableSections";
